module.exports = __webpack_public_path__ + "img/ttshop_dfk1.743c3906.svg";